export const isImage = (url?: string) => {
  if (!url) return false;
  return url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.jpeg');
};
